export const breakpointValues = {
  xsmall: 0,
  small: 480,
  medium: 768,
  large: 1024,
  xlarge: 1440,
  xxlarge: 1920,
};

// Must be in correct order from smallest first to largest last
export const breakpoints = {
  xsmall: breakpointValues.xsmall + "px",
  small: breakpointValues.small + "px",
  medium: breakpointValues.medium + "px",
  large: breakpointValues.large + "px",
  xlarge: breakpointValues.xlarge + "px",
  xxlarge: breakpointValues.xxlarge + "px",
};

export const breakpointClasses = [
  'xsmall',
  'small',
  'medium',
  'large',
  'xlarge',
];

export const rowMaxWidth = '1656px';

export const gridRowGutter = {
  xsmall: '1.6rem',
  medium: '2.4rem',
  large: '3.2rem',
  xlarge: '4.8rem',
};

export const gridColumnGutter = {
  xsmall: '1.6rem',
  medium: '2.4rem',
};
